import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js'
import Loader from './../shared/loader'
import DatePicker from 'vue2-datepicker'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import Pagination from './../shared/pagination'
import SimpleEncrypt from 'simple-encryptor'
import { BasicSelect } from 'vue-search-select'
import editPurchaseOrder from './editPurchaseOrder'
import printpo from './printpo'
import addPurchaseOrder from './addPurchaseOrder'
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import download from 'downloadjs';
import csvHelper from '../reports/importjsontocsv';
Vue.component("downloadExcel", JsonExcel);


export default {
	name: 'purchaseOrder',
	components: {
		//Paginate,
		Pagination,
		DatePicker,
		Loader,
		BasicSelect,
		editPurchaseOrder,
		printpo,
		addPurchaseOrder,
		JsonExcel,
		download
	},
	data: function() {
		return {
			currentPage: 1,
			totalPage: 0,
			pageLimit:10,
			totalrows:0,
			// currentPage: 0,
			//modalShow used for close the active/inactive modal(default)
			isLoading: false,
			modalShow: false,
			modalMessageShow: false,
			displayMsg: false,
			successErrorMsg: "",
			statusclass: '',
			pono: "",
			ponoFlt: "",
			fromDateFlt: "",
			toDateFlt: "",
			newActionMsg: "",
			modelMessage: "",
			activeClass: 'btn-success',
			warningClass: 'btn-warning',
			purchasingManager: 0,
			isInwardUserForPO: false,
			merchant: '',
			listPurchaseOrderData: [],
			listMerchantData: [],

			listClientData: [],
			listWarehouseData: [],
			// pageCount: 0,
			// pageno: 0,
			// pageLimit: 10,
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			ClientErr: '',
			WarehouseErr: '',
			addPOFlag : false,
			editPOFlag : false,
			viewPOFlag : false,
			lockingPOFlag : false,
			item:{},
		   merchant:'',
		   listMerchantData1:[],
		   merchantList:[],
		   merchantname:'',
		   mid:'',
		   //
		   showlist: true,
		   showeye:true,
		   showadd:true,
		   selectedRow: {},
		   filterData: {},
		   download: true,
		   listReportDataforxls: [],
		   csvFieldsForXls:{},
		   reportname:'',
		   resultCount: '',
		   limitExeed:'',
		   show: false,
		   dataFilter2:'',
		   isLoadingforxls: false,
		   fcWarehouse: false,
		   poStatus:'',
			 cancelmodalShow:false,
			 cancelOrderFlag:false,
			 cancelData : [],
			 roleId:''
		}
	},
	created: function() {
		// when a page loads,mounted() will be call
	},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var innerpermissionEncrypt = window.localStorage.getItem('innerpermissiondata')
		var innerbytes = CryptoJS.AES.decrypt(innerpermissionEncrypt.toString(), 'Key');
		var innerplaintext = innerbytes.toString(CryptoJS.enc.Utf8);
		var innerdetail = JSON.parse(innerplaintext);
		this.getComponentPermission(innerdetail);
		this.roleId = userdetail.roleid

		this.reportname = this.$t('purchaseOrder.purchaseOrderReport');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.key = '5VxHu9PR8QgPq7h67cUG0H34rYZQZmey';
		this.encryptor = SimpleEncrypt(this.key);
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.getMerchantList();

		this.user_type = userdetail.utype;
		this.loginUserEmail = userdetail.email;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				//this.getWarehouseList();
				this.getMerchantList();
			    this.showSelectWarehouse = true;

				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				//this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},
	methods: {
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			this.getPurchaseOrderListForXLS(3)

		},
		getPurchaseOrderListForXLS(csvCheck = 0){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			var fromDateFlt = '';
			var toDateFlt = '';

			if (this.fromDateFlt != "") {
				fromDateFlt = this.dateFormat(this.fromDateFlt, 1);
			}
			if (this.toDateFlt != "") {
				toDateFlt = this.dateFormat(this.toDateFlt, 2);
			}
			this.input = ({

				clientid: this.client,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				purchasingManager:this.purchasingManager,
				pono: this.ponoFlt,
				offset:(this.currentPage - 1) * 10,
				limit: this.pageLimit,
				fromDateFlt: this.dateFormat1(this.fromDateFlt),
				toDateFlt: this.dateFormat2(this.toDateFlt),
				loginUserEmail: this.loginUserEmail,
				supplierFlt: this.merchant,
				csvData: csvCheck,
				postatus:this.poStatus
			});
			Object.entries(this.input).forEach(([k,v]) =>{
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'purchaseOrderList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
			.then(result => {
				if (csvCheck == 3) {
					if (result.data.data.length > 0 ) {
						this.listReportDataforxls = [];
						this.csvFieldsForXls[this.$t('common.id')]='id',
						this.csvFieldsForXls[this.$t('purchaseOrder.productNumber')]='pono',
						this.csvFieldsForXls[this.$t('common.warehouseID')]='warehouseid',
						this.csvFieldsForXls[this.$t('client.clientId')]='clientid',
						this.csvFieldsForXls[this.$t('product.merchantId')]='merchantid',
						this.csvFieldsForXls[this.$t('common.createdDate')]='createddate',
						this.csvFieldsForXls[this.$t('common.createdBy')]='createdby',
						this.csvFieldsForXls[this.$t('common.lastModifiedBy')]='lastmodifiedby',
						this.csvFieldsForXls[this.$t('common.lastModifiedDate')]='lastmodifieddate',
						this.csvFieldsForXls[this.$t('common.status')]='status',
						this.csvFieldsForXls[this.$t('dataUploadLogs.poStatus')]='postatus',
						this.csvFieldsForXls[this.$t('purchaseOrder.poQty')]='poqty',
						this.csvFieldsForXls[ this.$t('purchaseOrder.poValue')]='povalue',
						this.csvFieldsForXls[this.$t('purchaseOrder.countPoDetails')]='countpodetails',
						this.csvFieldsForXls[this.$t('common.merchantName')]='merchantname',
						this.csvFieldsForXls[this.$t('purchaseOrder.smartPoCheck')]='smartpocheck',
						this.csvFieldsForXls[this.$t('purchaseOrder.canceledBy')]='canceledby',
						this.csvFieldsForXls[this.$t('purchaseOrder.canceledDate')]='canceleddate',

						this.listReportDataforxls = result.data.data;
					} else {
						if (result.data.status == true) {
							this.$alertify.success ('Report size is large. Please download from Data Transmission -> Download Reports')
						} else {
							this.$alertify.error(result.data.msg.message);
						}
					}
				}
			},error => {
				console.error(error);
			})
		},

//////////
		showAddForm() {

			this.showadd = false;
		},
		callParent2() {

			this.showadd=true;
		},
		showEditForm(data) {
			this.selectedRow = data
			this.showlist = false;
		},
		showViewForm(data) {
			this.selectedRow = data
			this.showeye = false;
		},
		callParent() {
			this.showlist = true;

		},
		callParent1() {
			this.showeye=true;
		},
		reset(){
			this.item={}
		},
		onSelect(item){

			this.item=item
			this.merchant=item.value
		},
		encryptData(encData){
       return this.encryptor.encrypt(encData);
		},
		decryptData(decData){
			return this.encryptor.decrypt(decData);
		},
		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// clientSelected() {
		// 	this.clientid = this.client;
		// 	this.merchant= '';
		// 	// this.warehouse= "";
		// 	// this.getWarehouseList();
		// 	this.pageno = this.pageCount = 0;
		// 	if(this.user_type!="warehouse_user"){
		// 		this.warehouse='';
		// 		this.getWarehouseList();
		// 	}
		// 	if (this.clientid) {
		// 		this.getMerchantList();
		// 		this.item={}
		// 		if (this.warehouseid) {
		// 			//  this.getPurchaseOrder();
		// 		} else {
		// 			this.getWarehouseList();
		// 		}
		// 	}
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.pageCount = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// this.getPurchaseOrder();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },

		getMerchantList() {
			this.listMerchantData1=[]
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
                        var merchantlistArray=[];
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{
							value: '',
							text: this.$t('common.selectMerchantPlaceHolder')
						}];
					   result.data.forEach(function(item){
						   merchantlistArray[item.merchantid]=item.merchantname;

					   })
					   this.merchantList=merchantlistArray;
					   this.listMerchantData.forEach(ele=>{
						this.listMerchantData1.push({
							"value":ele.merchantid,
							"text":ele.merchantname
						})
					   })

					}

				}, error => {
					console.error(error)
				})
		},

		getPurchaseOrder(csvCheck=3) {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');

			var dataFilter ={};
			if(csvCheck !== 1){
				this.show = false;
				this.download = true;
				// this.currentPage = 1;
			}
			if (window.localStorage.getItem('selectedClient') === 'undefined') {
				this.$alertify.error('Please select client')
				this.pageno = this.pageCount = 0;
				this.listPurchaseOrderData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse') === 'undefined') {
				this.$alertify.error('Please select warehouse');
				this.pageno = this.pageCount = 0;
				this.listPurchaseOrderData = [];
				return false;
			}
			this.checkFCWarehouse();
			var fromDateFlt = '';
			var toDateFlt = '';

			if (this.fromDateFlt != "") {
				fromDateFlt = this.dateFormat(this.fromDateFlt, 1);
			}
			if (this.toDateFlt != "") {
				toDateFlt = this.dateFormat(this.toDateFlt, 2);
			}
			this.isLoading = true;
			this.input = ({
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				pono: this.ponoFlt,
				fromDateFlt: this.dateFormat1(this.fromDateFlt),
				toDateFlt: this.dateFormat2(this.toDateFlt),
				purchasingManager: this.purchasingManager,
				loginUserEmail: this.loginUserEmail,
				supplierFlt: this.merchant,
				csvData: csvCheck,
				postatus:this.poStatus
			});
			Object.entries(this.input).forEach(([k,v]) =>{
				let skipkeys = ['offset','limit','csvData'];
				if(v !=null && v!='' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'purchaseOrderList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if(csvCheck ==1){
						this.show = true;
						this.download = false;
						this.listPurchaseOrderDatacsv = [];
						this.csvFields = {
							"id": this.$t('common.id'),
							"pono": this.$t('purchaseOrder.productNumber'),
							"warehouseid": this.$t('common.warehouseID'),
							"clientid": this.$t('client.clientId'),
							"merchantid": this.$t('product.merchantId'),
							"createddate": this.$t('common.createdDate'),
							"createdby": this.$t('common.createdBy'),
							"lastmodifiedby": this.$t('common.lastModifiedBy'),
							"lastmodifieddate": this.$t('common.lastModifiedDate'),
							"status": this.$t('common.status'),
							"postatus": this.$t('dataUploadLogs.poStatus'),
							"poqty": this.$t('purchaseOrder.poQty'),
							"povalue": this.$t('purchaseOrder.poValue') ,
							"countpodetails": this.$t('purchaseOrder.countPoDetails'),
							"merchantname": this.$t('common.merchantName'),
							"smartpocheck": this.$t('purchaseOrder.smartPoCheck'),
							"canceledby": this.$t('purchaseOrder.canceledBy'),
							"canceleddate": this.$t('purchaseOrder.canceledDate')

						};
						//var dateFilter = ['createddate','lastmodifieddate','canceleddate'];
						var dateFilter = [];
						var skipFilter = ['sessionid','merchantid','inwardid','suppliercompanyname'];
						this.listPurchaseOrderDatacsv = [];
						this.listPurchaseOrderDatacsv1= []
						this.listPurchaseOrderDatacsv = result.data.data;
						csvHelper.data.jsonToCSV(this.$t('purchaseOrder.purchaseOrderReport'), this.listPurchaseOrderDatacsv, this.csvFields,dateFilter,skipFilter,dataFilter)
						this.isLoading = false;
					}else{

						this.listPurchaseOrderData = result.data.result;
						this.resultCount = result.data.totalRows;
						this.totalrows=result.data.totalRows;
						this.setPageCounts(result.data.totalRows);
						this.isLoading = false;
					}

				}, error => {
					console.error(error)
				})
		},
		// getdatafromwms(){
		// 	if(this.client==1014){
		// 		if(this.ponoFlt=='' ){
		// 			this.$alertify.error('PO number is required')
		// 		}else if(this.warehouse==''){
		// 			this.$alertify.error('Warehouse is required')
		// 		}
		// 		else{
		// 			this.getfetchpofrommultiseller()
		// 		}
		// 		}

		// },
			getfetchpofrommultiseller() {
				let userToken = window.localStorage.getItem('userToken')
				let myStr = userToken.replace(/"/g, '');
				var ponoArr=[]
				if(this.ponoFlt){
					ponoArr.push(this.ponoFlt)
				}
				this.input = ({
					pono: ponoArr,
					warehouseid: window.localStorage.getItem('selectedWarehouse'),
					loginuser:this.loginUserEmail
				});
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'sendReqtoMultiseller',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {

						if (result.status == 200) {
							this.input = ({
								pono: this.ponoFlt,
								warehouseid: window.localStorage.getItem('selectedWarehouse'),
								loginuser:this.loginUserEmail
							})
							axios({
								method: 'POST',
								'url': apiUrl.api_url + 'pulldatafromMultiseller',
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr
								}
							}).then((res)=>{
								if(res.data.data[0].msg.status==false){
									this.$alertify.success(res.data.data[0].msg.msg)
								}else{
									if(res.data.data[0].status==true){
								this.$alertify.success(res.data.data[0].msg)

									}
								}
							})

						}
					}, error => {
						console.error(error);
						this.$alertify.success("Does not Updated, Try again.")
					})
		},
		// Search Purchase Order
		getPurchaseOrderSerach() {
			this.currentPage = 1;
			this.getPurchaseOrder(2);
		},
		jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = []) {
			var csvData = '';
			//Header
			if (this.title != null) {
			  csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			//Fields
			for (let key in data[0]) {
			  if (skipFilter.indexOf(key) == -1)
				csvData += csvfield[key] + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';
			//Data
			data.map(function(item) {
			  for (let key in item) {
				if (skipFilter.indexOf(key) == -1) {
				  var escapedCSV = item[key] + ''; // cast Numbers to string
				  if (escapedCSV.match(/[,"\n]/)) {
					escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
				  }
				  if (escapedCSV == 'null')
					csvData += ',';
				  else {
					if (dateFilter.indexOf(key) != -1)
					  csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
					else
					  csvData += escapedCSV + ',';
				  }
				}
			  }
			  csvData = csvData.slice(0, csvData.length - 1);
			  csvData += '\r\n';
			})
			//Footer
			if (this.footer != null) {
			  csvData += this.parseExtraData(this.footer, '${data}\r\n');
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData;
		  },
		  export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		  },
		  base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
			  u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
			  type: mime
			})
		  },
		getStatusRowData(poData, actionType) {
			this.modalShow = true;
			this.actionType = actionType;
			this.id = poData.id;
			this.pono = poData.pono;
			this.status = poData.status;
			this.postatus = poData.postatus;
			switch (actionType) {
				case "status":
					this.newStatus = "Active";
					if (poData.status == "Active" || poData.status == "active") {
						this.newStatus = "Inactive";
						this.statusclass = "btn-success"
					} else if (poData.status == "Inactive" || poData.status == "inactive") {
						this.newStatus = "Active";
						this.statusclass = "btn-danger"
					}
					this.newActionMsg = this.newStatus;
					break;
				case "postatus":
					this.newPoStatus = "unlock";
					if (poData.postatus == "Unlock" || poData.postatus == "unlock") {
						this.newPoStatus = "lock";
					} else if (poData.postatus == "Lock" || poData.postatus == "lock") {
						this.newPoStatus ="unlock";
					}
					this.newActionMsg = this.newPoStatus;
					break;
			}
		},
		getComponentPermission(innerdetail) {
			var component = 'purchaseOrder';
			var innerpermArr = {};
			for (var i = 0; i < innerdetail.length; i++) {
				if (innerdetail[i].controllerurl == component) {
					innerpermArr = innerdetail[i].permission;
					break;
				}
			}
			if (JSON.stringify(innerpermArr) == 'null') {
				//alert("wrong");
			} else {
				//console.log(innerpermArr);
				for (var i = 0; i < innerpermArr.length; i++) {
					if (innerpermArr[i].id == 'add') {
						this.addPOFlag = true;
					}
					if (innerpermArr[i].id == 'edit') {
						this.editPOFlag = true;
					}
					if (innerpermArr[i].id == 'view') {
						this.viewPOFlag = true;
					}
					if (innerpermArr[i].id == 'locking') {
						this.lockingPOFlag = true;
					}
					if (innerpermArr[i].id == 'cancel') {
						this.cancelOrderFlag = true;
					}
				}
			}

		},

		changeStatus() {
			if(this.fcWarehouse === true){
				if(this.newPoStatus === 'unlock'){
					this.$alertify.error("This PO can't be unlocked, contact admin.")
					return;
				}else{
					if(this.pushPOToFCWarehouse() == 0){
						this.$alertify.error("Does not updated, Try Again")
						return;
					}
				}
			}
			this.changeStatusXBClient();
		},
		changeStatusXBClient(){
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			this.input = ({
				status: this.newStatus,
				postatus: this.newPoStatus,
				id: this.id,
				pono: this.pono,
				actionType: this.actionType,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				lastmodifiedby: this.loginUserEmail,
				clientid: this.clientid
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'actionStatus',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.status == 200) {
						this.input = ({
							pono: this.pono,
							clientid: this.clientid
						})
						axios({
							method: 'POST',
							'url': apiUrl.api_url + 'elspo',
							'data': this.input,
							headers: {
								'Authorization': 'Bearer ' + myStr
							}
						});

						this.getPurchaseOrder(2);
						this.$alertify.success("Updated Successfully.")
					}
				}, error => {
					console.error(error);
					this.$alertify.error("Does not Updated, Try again.")
				})
		},

		pushPOToFCWarehouse(){
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			this.input = ({
				pono: this.pono,
				clientid: this.clientid
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'ext/inbound/pushPOToFC',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					return 1;
				}, error => {
					console.error(error);
					return 0;
				})
		},
		checkFCWarehouse(){
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse')
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'ext/inbound/checkFCWarehouse',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.errorCode != 0) {
						this.$alertify.error(result.data.msg)
						return;
					}else{
						this.fcWarehouse = result.data.data;
					}

				}, error => {
					console.error(error);
					this.$alertify.error("Unable to identify warehouse, contact admin.")
				})
		},

		//Sets total number of pages
		setPageCounts(total_rows) {
			if (total_rows > 0) {
				if (total_rows <= this.pageLimit) {
					this.totalPage = 1;
				} else {
					this.totalPage = Math.ceil(total_rows / this.pageLimit);
				}
			} else {
				this.totalPage = 0;
			}
		},

		//Call page number from pagination
		getPaginationData(currentPage) {
			this.pageno = (currentPage - 1) * this.pageLimit;
			this.getPurchaseOrder();
		},

		onPageChange(page) {
			this.currentPage = page;
			this.getPurchaseOrder(2)
		},

		resetFlt() {
			this.WarehouseErr = '';
			this.ClientErr = '';
			this.download = true;
			this.totalrows=0;
			this.ponoFlt = "";
			document.getElementById('ponoFlt').value = '';
			this.fromDateFlt = "";
			this.toDateFlt = "";
			this.merchant = "";
			// this.client = "";
			// this.warehouse = "";
			this.listPurchaseOrderData = [];
			this.resultCount = 0;
			this.item={}
			this.pageCount = 0;
			this.$validator.reset();
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
			this.poStatus = '';
		},

		getScore(val) {
			return parseFloat(val).toFixed(2);
		},

		dateFormat(date, type) {
			if (!date) return '';

			if (type == 1) {
				return moment(date).format('YYYY-MM-DD 00:00:00');
			} else {
				return moment(date).format('YYYY-MM-DD 23:59:00');
			}
		},
		getCancelConfirm(poData) {
			this.cancelmodalShow = true;
			this.cancelData = poData;
    },
		cancelOrder() {
			if(this.fcWarehouse === true){
				if(this.newPoStatus === 'unlock'){
					this.$alertify.error("This PO can't be unlocked, contact admin.")
					return;
				}else{
					if(this.pushPOToFCWarehouse() == 0){
						this.$alertify.error("Does not updated, Try Again")
						return;
					}
				}
			}
			this.cancelPo();
		},
		cancelPo(){
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			this.input = ({
				pono: this.cancelData.pono,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: this.clientid,
				roleid:this.roleId,
				lastmodifiedby: this.loginUserEmail
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'canclePO',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.status == true) {
						this.getPurchaseOrder(2);
						this.$alertify.success(result.data.msg)
					}else {
						this.getPurchaseOrder(2);
						this.$alertify.error(result.data.msg)
					}
				}, error => {
					console.error(error);
					this.$alertify.error("Does not Updated, Try again.")
				})
		},
		//validate all form fields on onsubmit()
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/purchaseOrder/purchaseOrder.component.js